exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footers[data-v-078753dd]{text-align:center;font-size:14px;color:#808695}.footers .title[data-v-078753dd]{font-size:14px;color:#808695}.fixed-header+.app-main[data-v-078753dd]{padding-top:50px}.hasTagsView .app-main[data-v-078753dd]{background:#f5f5f5;min-height:calc(100vh - 36px);overflow-y:auto}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:80px}.el-popup-parent--hidden .fixed-header[data-v-078753dd]{padding-right:15px}", ""]);

// exports
